import {
  COMERCIO_EXTERIOR_SERVICE_MAIN_457X380,
  COMERCIO_EXTERIOR_SHOW_IMAGE_320X240,
  CUSTOMS_CLEARANCE_SHOW_IMAGE_320X240,
  CUSTOMS_SUPPORT_SHOWCASE_IMAGE_457X380,
  IMPORT_EXPORT_MAIN_IMG_457X380,
  IMPORT_EXPORT_SHOW_IMAGE_320X240,
  INTERNATIONAL_LOGISTICS_MAIN_IMG_457X380,
  INTERNATIONAL_LOGISTICS_SHOW_IMAGE_320X240,
  RIGHT_ARROW,
} from "../lib/assets";

/** Structural service data (locale-free). Copy lives in locales/{locale}/services.json */
export const SERVICES_STRUCTURE = [
  {
    id: 1,
    href: "/services-details-4",
    src: RIGHT_ARROW,
    showcaseImage: COMERCIO_EXTERIOR_SHOW_IMAGE_320X240,
    showCaseIcon: "flaticon-briefcase",
    mainDetailImg: COMERCIO_EXTERIOR_SERVICE_MAIN_457X380,
  },
  {
    id: 2,
    href: "/services-details-4",
    src: RIGHT_ARROW,
    showcaseImage: CUSTOMS_CLEARANCE_SHOW_IMAGE_320X240,
    showCaseIcon: "flaticon-briefcase",
    mainDetailImg: CUSTOMS_SUPPORT_SHOWCASE_IMAGE_457X380,
  },
  {
    id: 3,
    href: "/services-details-4",
    src: RIGHT_ARROW,
    showcaseImage: IMPORT_EXPORT_SHOW_IMAGE_320X240,
    showCaseIcon: "flaticon-briefcase",
    mainDetailImg: IMPORT_EXPORT_MAIN_IMG_457X380,
  },
  {
    id: 4,
    href: "/services-details-4",
    src: RIGHT_ARROW,
    showcaseImage: INTERNATIONAL_LOGISTICS_SHOW_IMAGE_320X240,
    showCaseIcon: "flaticon-briefcase",
    mainDetailImg: INTERNATIONAL_LOGISTICS_MAIN_IMG_457X380,
  },
];

export const getServices = (t) =>
  SERVICES_STRUCTURE.map((service) => {
    const copy = t(String(service.id), { ns: "services", returnObjects: true });
    return {
      ...service,
      ...(copy && typeof copy === "object" ? copy : {}),
    };
  });

export const getServiceById = (t, id) =>
  getServices(t).find((service) => service.id === Number(id));

/** @deprecated Prefer getServices(t) */
export const SERVICES_LIST = SERVICES_STRUCTURE;
